var map = {
	"./account.svg": "ef22",
	"./address-book.svg": "921b",
	"./adjust.svg": "f357",
	"./alarm.svg": "3c85",
	"./badge.svg": "b14d",
	"./bell-alt.svg": "86a5",
	"./brainstorming.svg": "6728",
	"./businessman.svg": "4c25",
	"./chart-bar-graph.svg": "ef28",
	"./chart-pie.svg": "2872",
	"./chat.svg": "22b2",
	"./coupon.svg": "e24d",
	"./data.svg": "5a0a",
	"./dataBoard.svg": "cdae",
	"./deliverGoods.svg": "008b",
	"./device.svg": "2c87",
	"./edit.svg": "aa46",
	"./equipment.svg": "b596",
	"./franchisee.svg": "8ab3",
	"./gear-alt.svg": "32f9",
	"./gears.svg": "5016",
	"./generalSetting.svg": "2cdf",
	"./grocery.svg": "a6fc",
	"./hard-disk.svg": "ef9d",
	"./heart.svg": "c40a",
	"./history.svg": "c023",
	"./home.svg": "6bbe",
	"./icon-activity.svg": "e36d",
	"./icon-afterSale.svg": "bc01",
	"./icon-cancel.svg": "10ef",
	"./icon-commodity.svg": "ffd5",
	"./icon-dataBoard.svg": "a094",
	"./icon-dataMange.svg": "c63d",
	"./icon-debugging.svg": "2f66",
	"./icon-delete.svg": "c046",
	"./icon-determine.svg": "5c55",
	"./icon-disable.svg": "858f",
	"./icon-edit.svg": "489e",
	"./icon-enable.svg": "4818",
	"./icon-equipment.svg": "b5bb",
	"./icon-equityCard.svg": "eafe",
	"./icon-home.svg": "2eec",
	"./icon-joinIn.svg": "fb63",
	"./icon-log.svg": "e181",
	"./icon-make.svg": "3957",
	"./icon-makeLog.svg": "f425",
	"./icon-material.svg": "abc5",
	"./icon-modular.svg": "cfc3",
	"./icon-notice.svg": "f06d",
	"./icon-order.svg": "5989",
	"./icon-partners.svg": "4bb2",
	"./icon-store.svg": "bbdc",
	"./icon-system.svg": "524a",
	"./icon-transport.svg": "098e",
	"./icon-user.svg": "7462",
	"./icon-userMange.svg": "1592",
	"./icon-voucher.svg": "f924",
	"./icon-workingMode.svg": "5f46",
	"./inventory.svg": "faa7",
	"./live-messenger.svg": "3593",
	"./megaphone.svg": "5e33",
	"./military.svg": "fa76",
	"./order.svg": "11ff",
	"./orderMange.svg": "5543",
	"./placeAnOrder.svg": "d300",
	"./price.svg": "5a55",
	"./sale-discount.svg": "54e8",
	"./search-user.svg": "2c26",
	"./serveMange.svg": "73e5",
	"./serviceConfig.svg": "22de",
	"./stamp.svg": "23a9",
	"./store.svg": "443b",
	"./tags.svg": "94f8",
	"./truck-alt.svg": "00e9",
	"./truck-loaded.svg": "bc0e",
	"./ui-user-group.svg": "046d",
	"./ui-user.svg": "d347",
	"./user.svg": "b3b5",
	"./userManagement.svg": "46ae",
	"./users-alt-2.svg": "6c1f",
	"./visualization.svg": "1bec",
	"./workReport.svg": "6dc6",
	"./workingMode.svg": "cb5e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";